<mat-tab-group animationDuration="0ms" class="pt-2">
  <mat-tab>
    <ng-template mat-tab-label>
      {{ 'waters.reviews.tab.guest-ratings' | translate }}
      <app-count-badge [count]="ratingsCount()" />
    </ng-template>
    <app-water-ratings [waterId]="waterId()" (totalCount)="ratingsCount.set($event)" />
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      {{ 'waters.reviews.tab.testimonials' | translate }}
      <app-count-badge [count]="testimonialsCount()" />
    </ng-template>
    <app-water-testimonials [waterId]="waterId()" (totalCount)="testimonialsCount.set($event)" />
  </mat-tab>
</mat-tab-group>
